<div class="main-content table-page table-page--compact mis-proyectos-page">
  <div class="container-fluid">
    <ng-container *ngIf="mostrarPrincipal; else proyectoDetailView">
      <section class="table-page__hero">
        <div class="table-page__copy">
          <h1>Mis Proyectos</h1>
          <p>Consulte los proyectos asignados y navegue a épicas o sprints desde una sola vista.</p>
        </div>
      </section>

      <section class="table-page__card">
        <div class="table-page__toolbar">
          <mat-form-field appearance="outline" class="table-page__search-field">
            <mat-label>Buscar proyecto</mat-label>
            <input aria-label="Buscar proyecto" matInput type="text" maxlength="200" [(ngModel)]="nomProyecto"
              (keyup)="consultaMisProyectos(1)" autocomplete="off" />
            <button *ngIf="nomProyecto" type="button" matSuffix mat-icon-button (click)="clearNombrePro()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="projects.length > 0; else misProyectosEmptyState">
            <thead>
              <tr>
                <th>Proyecto</th>
                <th>Área</th>
                <th>Cliente</th>
                <th>Fechas</th>
                <th class="table-page__actions-head table-page__actions--multi">Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let proyecto of projects">
                <td>
                  <div class="table-page__cell-stack">
                    <strong class="table-page__name">{{ proyecto.nombre || "Sin nombre" }}</strong>
                    <span class="table-page__subtext">
                      {{ getProjectIdentifier(proyecto) }} · {{ getProjectShortName(proyecto) }}
                    </span>
                  </div>
                </td>
                <td>
                  <span class="table-page__text">{{ proyecto.nomArea || "Sin área" }}</span>
                </td>
                <td>
                  <span class="table-page__text">{{ proyecto.nombreCliente || "Sin cliente" }}</span>
                </td>
                <td>
                  <span class="table-page__text">{{ getDateRangeLabel(proyecto) }}</span>
                </td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button type="button" class="table-page__action-btn" matTooltip="Actividades"
                      (click)="consultarActividades(proyecto)">
                      <i class="material-icons">assignment</i>
                    </button>
                    <button type="button" class="table-page__action-btn" matTooltip="Sprints"
                      (click)="consultaSprint(proyecto)">
                      <i class="material-icons">view_kanban</i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #misProyectosEmptyState>
            <div class="table-page__empty" *ngIf="!loading; else misProyectosLoadingState">
              <i class="material-icons">folder_open</i>
              <strong>No se encontraron proyectos asignados</strong>
              <span>Intente con otro criterio de búsqueda o verifique la asignación de proyectos.</span>
            </div>
          </ng-template>

          <ng-template #misProyectosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando proyectos...</strong>
            </div>
          </ng-template>
        </div>

        <div class="table-page__footer" *ngIf="showPagination">
          <div class="table-page__meta">
            <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} proyectos</span>
            <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

            <label class="table-page__page-size">
              <span>Ver:</span>
              <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
              </select>
            </label>
          </div>

          <div class="table-page__pager" *ngIf="totalPages > 0">
            <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
              Inicio
            </button>
            <button type="button" class="table-page__pager-link" (click)="previousPage()"
              [disabled]="currentPage === 1">
              Anterior
            </button>

            <ng-container *ngFor="let item of getPaginationItems()">
              <button *ngIf="isPageNumber(item); else misProyectosPagerEllipsis" type="button"
                class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
                {{ item }}
              </button>

              <ng-template #misProyectosPagerEllipsis>
                <span class="table-page__pager-ellipsis">...</span>
              </ng-template>
            </ng-container>

            <button type="button" class="table-page__pager-link" (click)="nextPage()"
              [disabled]="currentPage === totalPages">
              Siguiente
            </button>
            <button type="button" class="table-page__pager-link" (click)="lastPage()"
              [disabled]="currentPage === totalPages">
              Último
            </button>
          </div>
        </div>
      </section>
    </ng-container>

    <ng-template #proyectoDetailView>
      <app-consulta-epicas *ngIf="mostrarActividades" [id]="proyecto.id" (regresar)="mostrarLista()">
      </app-consulta-epicas>
      <app-consulta-sprint *ngIf="mostrarSprint" [proyecto]="proyecto" (regresar)="mostrarLista()">
      </app-consulta-sprint>
    </ng-template>
  </div>
</div>
